import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsersPageComponent } from './users-page/users-page.component';
import { UserComponent } from './user/user.component';
import { SharedModule } from '../../shared/shared.module';
import { UsersRoutingModule } from './users-routing.module';
import { UserGroupsComponent } from './user/user-groups/user-groups.component';
import { UserRetailPlacesComponent } from './user/user-retail-places/user-retail-places.component';
import { UserPermissionsComponent } from './user/user-permissions/user-permissions.component';
import { EmptyListComponent } from '../../shared/empty-list/empty-list.component';

@NgModule({
  imports: [
    SharedModule,
    UsersRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    EmptyListComponent,
  ],
  exports: [],
  declarations: [
    UsersPageComponent,
    UserComponent,
    UserGroupsComponent,
    UserRetailPlacesComponent,
    UserPermissionsComponent,
  ],
  providers: [],
})
export class UsersModule {
}
